import React from "react";
import { GameBox } from "../../containers";

export const GamePage = () => {
  return (
    <div>
      <GameBox />
    </div>
  );
};
